import { countCellIdMaps, loadCellIdMap, countWildlifeThumbnailSheets, loadWildlifeThumbnails } from '~app/actions/database';
import { countFavorites, restoreFavorites } from '~app/actions/favorites';
import { countLowResLayers, loadLowResLayers } from '~app/actions/layers';
import { countVectors, loadAllVectors } from '~app/actions/vector';

import Logging from '~app/core/logging';

const log = Logging.getLogger('app.actions.init');

export const LOADING_STARTED = 'LOADING_STARTED';
export const LOADING_PROGRESS_UPDATE = 'LOADING_PROGRESS_UPDATE';
export const LOADING_FINISHED = 'LOADING_FINISHED';

export function load() {
  return async (dispatch, getState) => {
    let completionPercent = 0.0;
    const increment = 1.0 / countWorkItems(getState());
    const updateProgress = (message) => {
      completionPercent += increment;
      dispatch(updateLoadingProgress(message, completionPercent));
    };

    dispatch(startLoading('Loading assets ...', completionPercent));
    await dispatch(loadLowResLayers(() => updateProgress('Loading base maps...')));
    await dispatch(loadAllVectors(() => updateProgress('Loading vectors...')));
    await dispatch(loadCellIdMap(() => updateProgress('Loading geo cell data...')));
    await dispatch(loadWildlifeThumbnails(() => updateProgress('Loading wildlife thumbnails...')));
    await dispatch(restoreFavorites(() => updateProgress('Loading favorite locations...')));
    dispatch(finishLoading());
  };
}

function countWorkItems(state) {
  return countCellIdMaps() +
    countWildlifeThumbnailSheets() +
    countFavorites() +
    countLowResLayers(state) +
    countVectors();
}

export function startLoading(message, percentComplete = null) {
  log.info('loading started');
  return {
    type: LOADING_STARTED,
    message,
    progressPct: percentComplete,
  };
}

export function updateLoadingProgress(message, percentComplete = undefined) {
  return {
    type: LOADING_PROGRESS_UPDATE,
    message,
    progressPct: percentComplete,
  };
}

export function finishLoading() {
  log.info('loading finished');
  return {
    type: LOADING_FINISHED,
  };
}



// WEBPACK FOOTER //
// ./src/actions/init.js